import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, inject } from '@angular/core'
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap'

@Component({
  selector: 'copy-to-clipboard',
  imports: [
    NgbTooltipModule
  ],
  templateUrl: './copy-to-clipboard.component.html',
  styleUrl: './copy-to-clipboard.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CopyToClipboardComponent {
  private elementRef: ElementRef = inject(ElementRef)
  private changeDetector = inject(ChangeDetectorRef)

  copyStatus: string | null = null

  async copyToClipboard() {
    // Implement copy to clipboard functionality
    const element = this.elementRef.nativeElement.parentElement.parentElement

    const htmlContent = element.innerHTML.replace(/<copy-to-clipboard.*?copy-to-clipboard>/g, '').replace(/<export-to-xls.*?export-to-xls>/g, '').replace(/<thumbs-comment.*?thumbs-comment>/g, '') // Remove the custom element tag if present
    const plainTextContent = element.innerText // Use innerText for plain text representation

    try {
      // Create a Blob for the HTML content
      const htmlBlob = new Blob([htmlContent], { type: 'text/html' })
      // Create a Blob for the plain text content
      const plainTextBlob = new Blob([plainTextContent], { type: 'text/plain' })

      // Create a ClipboardItem with both HTML and plain text versions
      const item = new (window as any).ClipboardItem({
        'text/html': htmlBlob,
        'text/plain': plainTextBlob
      })

      // Write to the clipboard
      await navigator.clipboard.write([item])
      this.copyStatus = '&nbsp&nbspCopied!'
    } catch (err) {
      console.error('Failed to copy styled HTML to clipboard:', err)
      // Fallback to plain text copy if styled copy fails for some reason
      this.copyStatus = `Failed to copy styled text.`
    }
    this.changeDetector.detectChanges()


    // Clear status message after a few seconds
    setTimeout(() => {
      this.copyStatus = ''
      this.changeDetector.markForCheck()
    }, 3000)


  }
}
